import { render } from "./screenBtn.vue?vue&type=template&id=dda11934&scoped=true"
import script from "./screenBtn.vue?vue&type=script&lang=js"
export * from "./screenBtn.vue?vue&type=script&lang=js"

import "./screenBtn.vue?vue&type=style&index=0&id=dda11934&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda11934"]])

export default __exports__